import { useState } from "react";
import { Button, Col, Row, Skeleton, Typography } from "antd";
import { Publication } from "interfaces/websiteContent";
import axios from "axios";
import eagleImage from "assets/images/publicationsImages/eagle.png";
import owlImage from "assets/images/publicationsImages/owl.png";
import coronaVirusImage from "assets/images/publicationsImages/coronaVirus.png";
import useViewport from "components/UseViewport/UseViewport";
import { StyledCard, StyledImg } from "./style";

const { Title, Text } = Typography;

export interface Props {
  surveyDiplom: Publication[];
  surveyAlumini: Publication[];
  surveyCovid: Publication[];
}

const EarlierSurveys: React.FC<Props> = ({ surveyDiplom, surveyAlumini, surveyCovid }) => {
  const { width } = useViewport();
  const isMobile = width <= 768;
  const [showAllDiplom, setShowAllDiplom] = useState(false);
  const [showAllAlumini, setShowAllAlumini] = useState(false);
  const [showAllCovid, setShowAllCovid] = useState(false);

  const dateFormaterHelper = (dateString: string) => {
    const date = new Date(dateString);
    return `${date.getDate().toString().padStart(2, "0")}.${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}.${date.getFullYear()}`;
  };

  const oldPublicationListItem = (
    surveyData: Publication[],
    image: string,
    showAll: boolean,
    setShowAll: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    const navigateTo = (url: string) => {
      window.open(url, "_blank", "noopener,noreferrer");
    };
    const visibleData = showAll ? surveyData : surveyData.slice(0, 3);
    return (
      <>
        {visibleData.map(survey => (
          <StyledCard
            hoverable
            key={survey.id}
            onClick={() =>
              navigateTo(
                survey.publication_file.includes("http")
                  ? survey.publication_file
                  : axios.defaults.baseURL + survey.publication_file
              )
            }
          >
            <Row gutter={20}>
              <Col xs={8} sm={8}>
                <StyledImg src={image} alt="" />
              </Col>
              <Col
                xs={16}
                sm={16}
                style={{ display: "flex", flexDirection: "column", justifyContent: "center", height: "90px" }}
              >
                <Text strong ellipsis>
                  {survey.title}
                </Text>
                <Text type="secondary"> Publisert: {dateFormaterHelper(survey.publication_date)}</Text>
              </Col>
            </Row>
          </StyledCard>
        ))}
        {surveyData.length > 3 && (
          <Button onClick={() => setShowAll(!showAll)} style={{ marginTop: ".2em" }}>
            {showAll ? "Vis færre" : "Vis alle"}
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      <Row justify="center" gutter={[40, 40]} style={{ marginTop: 0 }}>
        <Col xs={24} sm={24} md={8}>
          <Title level={4}>Diplomundersøkelsen</Title>
          {surveyDiplom.length !== 0 ? (
            oldPublicationListItem(surveyDiplom, eagleImage, showAllDiplom, setShowAllDiplom)
          ) : (
            <Skeleton.Button
              active
              block
              style={{ height: "90px", width: isMobile ? "100%" : "360px", maxWidth: "100%" }}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Title level={4}>Alumniundersøkelsen</Title>
          {surveyAlumini.length !== 0 ? (
            oldPublicationListItem(surveyAlumini, owlImage, showAllAlumini, setShowAllAlumini)
          ) : (
            <Skeleton.Button
              active
              block
              style={{ height: "90px", width: isMobile ? "100%" : "360px", maxWidth: "100%" }}
            />
          )}
        </Col>
        <Col xs={24} sm={24} md={8}>
          <Title level={4}>Koronaundersøkelsen</Title>
          {surveyCovid.length !== 0 ? (
            oldPublicationListItem(surveyCovid, coronaVirusImage, showAllCovid, setShowAllCovid)
          ) : (
            <Skeleton.Button
              active
              block
              style={{ height: "90px", width: isMobile ? "100%" : "360px", maxWidth: "100%" }}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default EarlierSurveys;
